var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .profileEdita {\n                fill: #555;\n                stroke: #fff;\n                stroke-width: 2px;\n            }\n\n            .profileEditb {\n                fill: #fff;\n            }\n\n            .profileEditc {\n                stroke: none;\n            }\n\n            .profileEditd {\n                fill: none;\n            }\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-577.57 -204)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "profileEdita",
    transform: "translate(577.57 204)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "profileEditc",
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "profileEditd",
    cx: 16,
    cy: 16,
    r: 15
  })), /*#__PURE__*/React.createElement("path", {
    className: "profileEditb",
    d: "M231.575,204.82a1.852,1.852,0,1,0,1.828,1.852A1.84,1.84,0,0,0,231.575,204.82Zm4.874-1.852h-1.462a.543.543,0,0,1-.481-.351l-.378-1.149a.544.544,0,0,0-.481-.351H229.5a.543.543,0,0,0-.481.351l-.378,1.149a.544.544,0,0,1-.481.351H226.7a1.23,1.23,0,0,0-1.219,1.234v5.555a1.23,1.23,0,0,0,1.219,1.234h9.749a1.23,1.23,0,0,0,1.219-1.234V204.2A1.23,1.23,0,0,0,236.449,202.969Zm-4.874,6.789a3.086,3.086,0,1,1,3.047-3.086A3.067,3.067,0,0,1,231.575,209.758Zm4.448-4.692a.432.432,0,1,1,.427-.432A.429.429,0,0,1,236.022,205.066Z",
    transform: "translate(362.222 13.72)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditProfile);
export default __webpack_public_path__ + "static/media/editProfile.29418600.svg";
export { ForwardRef as ReactComponent };